import { connect } from 'react-redux'
import { updateTable } from 'redux/modules/table'
import { updateMapSize } from 'redux/modules/settings'
import { showModal } from 'redux/modules/modals'
import AdminPoolTablesComponent from '../components/AdminPoolTablesComponent'

const mapActionCreators = {
  updateTable,
  updateMapSize,
  showModal
}

const mapStateToProps = state => {
  return {
    tables: state.tables.list,
    map: state.settings.size
  }
}

export default connect(mapStateToProps, mapActionCreators)(
  AdminPoolTablesComponent
)



// WEBPACK FOOTER //
// ./src/routes/Admin/Tables/containers/AdminTablesContainer.js